export default "__VITE_ASSET__DSNxLiW3__"